import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import * as powerbi from "powerbi-client";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import "../App.css";

export default function UserDashboard()
{
  const embedRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [dashboards, setDashboards] = useState([]);
  const [selectedDashboard, setSelectedDashboard] = useState(null);

  // Redirect to login if user is not logged in
  useEffect(() =>
  {
    if (!user)
    {
      window.location.href = "/login";
    }
  }, [user]);

  // Fetch dashboards assigned to the user
  useEffect(() =>
  {
    if (!user) return;

    const fetchDashboards = async () =>
    {
      try
      {
        const res = await axios.get(
          `https://bidashboard.miplapp.in/backend/api/user-dashboards.php?username=${user.username}`
        );
        const data = Array.isArray(res.data) ? res.data : res.data.assignedDashboards || [];
        setDashboards(data);
      } catch (err)
      {
        console.error("Failed to load dashboards:", err);
      }
    };

    fetchDashboards();
  }, [user]);

  // Embed selected Power BI report
  const embedReport = async (dashboardId) =>
  {
    if (!embedRef.current) return;

    try
    {
      const res = await axios.get(
        `https://bidashboard.miplapp.in/backend/api/embed.php?reportKey=${dashboardId}`
      );
      const { embedUrl, embedToken, reportId } = res.data;

      if (!embedUrl || !embedToken || !reportId)
      {
        console.error("Missing embed data:", res.data);
        return;
      }

      const powerbiService = new powerbi.service.Service(
        powerbi.factories.hpmFactory,
        powerbi.factories.wpmpFactory,
        powerbi.factories.routerFactory
      );

      embedRef.current.style.width = "100%";
      embedRef.current.style.height = "600px";

      // Reset before embedding a new report
      powerbiService.reset(embedRef.current);

      powerbiService.embed(embedRef.current, {
        type: "report",
        tokenType: powerbi.models.TokenType.Embed,
        accessToken: embedToken,
        embedUrl,
        id: reportId,
        settings: {
          panes: { filters: { visible: false }, pageNavigation: { visible: true } },
        },
      });
    } catch (err)
    {
      console.error("Error embedding report:", err);
    }
  };

  // Handle dashboard selection
  const handleDashboardClick = (dashboardId) =>
  {
    setSelectedDashboard(dashboardId);
    embedReport(dashboardId);
  };

  return (
    <>
      <Topbar
        onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
        collapsed={sidebarCollapsed}
      />
      <Sidebar collapsed={sidebarCollapsed} role={user?.role} />

      <div className={`main-content modern-admin ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="welcome-banner">
          <h2>👋 Welcome, {user?.username}</h2>
          <p>Select a dashboard to view analytics</p>
        </div>

        <div className="dashboard-grid">
          {dashboards.length === 0 ? (
            <p>No dashboards assigned.</p>
          ) : (
            dashboards.map((dash) =>
            {
              const dashIdStr = dash.id?.toString();
              return (
                <div
                  key={dashIdStr}
                  className={`dashboard-card-modern ${selectedDashboard === dashIdStr ? "active" : ""
                    }`}
                  onClick={() => handleDashboardClick(dashIdStr)}
                >
                  <div className="card-content">
                    <h3>{dash.title}</h3>
                    <p>View detailed insights</p>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div ref={embedRef} className="dashboard-container-modern"></div>
      </div>
    </>
  );
}
